import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router'

import { api } from '../api'

// The mapping editor edits one bucket's build spec, so it lives inside each
// bucket (BucketDetail, the Mapping tab). This landing lists the buckets so
// "Mapping" in the nav has somewhere to go: pick a bucket to edit its
// inputs, field map, joins and rules.
export function Mapping() {
  const q = useQuery({ queryKey: ['buckets'], queryFn: api.buckets })

  return (
    <section className="page">
      <header className="page-h">
        <h1>Mapping editor</h1>
      </header>
      <p className="muted">
        A bucket's field mapping is edited on the bucket itself. Pick a bucket to open its mapping
        (inputs, field map, joins, validation rules) with a live preview.
      </p>
      {q.isLoading ? (
        <p className="muted">Loading…</p>
      ) : q.error ? (
        <p className="muted">Could not load buckets.</p>
      ) : !q.data?.length ? (
        <p className="muted">
          No buckets yet. Create one on the <Link to="/buckets">Buckets</Link> page first.
        </p>
      ) : (
        <ul className="list">
          {q.data.map((b) => (
            <li key={b.slug}>
              <Link to={`/buckets/${encodeURIComponent(b.slug)}`}>{b.title || b.slug}</Link>
              <span className="muted mono"> {b.slug}</span>
              <span className="muted">
                {' · '}
                {b.spec_version ? `spec v${b.spec_version}` : 'no spec yet'}
                {b.inputs?.length ? ` · ${b.inputs.length} input${b.inputs.length === 1 ? '' : 's'}` : ''}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
